var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-row",
        { staticClass: "btn-group" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-item",
              attrs: { type: "primary", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.handleBtn("back")
                },
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("after-sales::in-box::detail_reply")) + " "
              ),
            ]
          ),
          _c(
            "el-dropdown",
            {
              staticClass: "btn-item",
              attrs: { trigger: "click" },
              on: {
                command: function (val) {
                  return _vm.handleCommand(val, "tag")
                },
              },
            },
            [
              _c("el-button", { attrs: { type: "default", size: "medium" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("after-sales::in-box::detail_mark_as")) +
                    " "
                ),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]),
              _c(
                "el-dropdown-menu",
                {
                  attrs: { slot: "dropdown", appendToBody: false },
                  slot: "dropdown",
                },
                _vm._l(_vm.tagDtolist, function (item, i) {
                  return _c(
                    "el-dropdown-item",
                    { key: i, attrs: { command: item.value } },
                    [
                      _c("span", {
                        style:
                          "margin-right:4px;border-radius: 2px;display:inline-block;width:10px;height: 8px;vertical-align: middle;background: " +
                          item.color,
                      }),
                      _vm._v(" " + _vm._s(item.label) + " "),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-dropdown",
            {
              staticClass: "btn-item",
              attrs: { trigger: "click" },
              on: {
                command: function (val) {
                  return _vm.handleCommand(val, "type")
                },
              },
            },
            [
              _c("el-button", { attrs: { type: "default", size: "medium" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("after-sales::in-box::detail_classify")) +
                    " "
                ),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]),
              _c(
                "el-dropdown-menu",
                {
                  attrs: { slot: "dropdown", appendToBody: false },
                  slot: "dropdown",
                },
                _vm._l(_vm.types, function (item, i) {
                  return _c(
                    "el-dropdown-item",
                    { key: i, attrs: { command: item.value } },
                    [_vm._v(" " + _vm._s(item.label) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "box-wrap", attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { staticClass: "title desc-item", attrs: { span: 24 } },
            [
              _c(
                "span",
                {
                  staticClass: "oneline title-info",
                  attrs: { title: _vm.form.subject },
                },
                [_vm._v(" " + _vm._s(_vm.form.subject) + " ")]
              ),
              _c(
                "p",
                _vm._l(_vm.form.tagDtolist, function (tag) {
                  return _c(
                    "el-tag",
                    {
                      key: tag.id,
                      style:
                        "background-color:" +
                        tag.color +
                        ";\n            border-color: " +
                        tag.color +
                        ";\n            color: #fff;margin-right: 4px;margin-bottom: 4px;",
                      attrs: { closable: "" },
                      on: {
                        close: function ($event) {
                          return _vm.handleCloseTag(_vm.form, tag.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            tag.parentName
                              ? tag.parentName + "- " + tag.name
                              : tag.name
                          ) +
                          " "
                      ),
                    ]
                  )
                }),
                1
              ),
            ]
          ),
          _c("el-col", { staticClass: " desc-item", attrs: { lg: 6, md: 8 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("after-sales::in-box::detail_email_id")) + "："
              ),
            ]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.$dataCheck(_vm.form.id))),
            ]),
          ]),
          _c("el-col", { staticClass: " desc-item", attrs: { lg: 6, md: 8 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("after-sales::in-box::detail_recipient")) + "："
              ),
            ]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.$dataCheck(_vm.form.to))),
            ]),
          ]),
          _c("el-col", { staticClass: "desc-item", attrs: { lg: 6, md: 8 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("after-sales::in-box::detail_sender")) + "："
              ),
            ]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.$dataCheck(_vm.form.from))),
            ]),
          ]),
          _c("el-col", { staticClass: " desc-item", attrs: { lg: 6, md: 8 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("after-sales::in-box::detail_handler")) + "："
              ),
            ]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.$dataCheck(_vm.form.staffName))),
            ]),
          ]),
          _c("el-col", { staticClass: " desc-item", attrs: { lg: 6, md: 8 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("after-sales::in-box::detail_sort")) + "："),
            ]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.$dataCheck(_vm.form.categoryName))),
            ]),
          ]),
          _c("el-col", { staticClass: " desc-item", attrs: { lg: 6, md: 8 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("after-sales::in-box::detail_status")) + "："
              ),
            ]),
            _c("span", { staticClass: "value" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$dataCheck(
                      {
                        0: _vm.$t("after-sales::in-box::status_未回复"),
                        1: _vm.$t("after-sales::in-box::status_回复"),
                        2: _vm.$t("after-sales::in-box::status_超时未回复"),
                      }[_vm.form.status]
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
          _c("el-col", { staticClass: " desc-item", attrs: { lg: 6, md: 8 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("after-sales::in-box::detail_reply_time")) + "："
              ),
            ]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.$dataCheck(_vm.form.latestReplyTime))),
            ]),
          ]),
          _c("el-col", { staticClass: "desc-item", attrs: { lg: 6, md: 8 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("after-sales::in-box::detail_replier")) + "："
              ),
            ]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.$dataCheck(_vm.form.latestReplyPersonName))),
            ]),
          ]),
          _c("el-col", { staticClass: " desc-item", attrs: { lg: 6, md: 8 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("after-sales::in-box::detail_send_time")) + "："
              ),
            ]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.$dataCheck(_vm.form.sentDate))),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "remark-info" },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "60px" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.t("after-sales::in-box::detail_remark") },
                },
                [
                  _c(
                    "div",
                    { staticClass: "txt-box" },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 4, maxRows: 10 },
                          placeholder: _vm.t(
                            "after-sales::in-box::detail_remark_placeholder"
                          ),
                        },
                        on: { blur: _vm.handleSaveRemark },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                      _c("el-button", {
                        staticClass: "loading-save",
                        attrs: { type: "default", loading: _vm.remarkLoading },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "content-box" },
        [
          _c("RichEditor", {
            attrs: { initData: _vm.reInit, placeholder: "请输入正文" },
            model: {
              value: _vm.form.content,
              callback: function ($$v) {
                _vm.$set(_vm.form, "content", $$v)
              },
              expression: "form.content",
            },
          }),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "footer-copy",
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              return _vm.$copy(_vm.form.content)
            },
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.t("after-sales::in-box::detail_copy_content")) +
              " "
          ),
        ]
      ),
      _c("drawerEmail", {
        attrs: { drawRow: _vm.drawRow },
        model: {
          value: _vm.drawerVisable,
          callback: function ($$v) {
            _vm.drawerVisable = $$v
          },
          expression: "drawerVisable",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }